import React, { useContext } from 'react';
import { Doughnut } from 'react-chartjs-2';
import PropTypes from 'prop-types';

import DashboardContext from '#/context';
import useWidget from '#/hooks/useWidget';
import NotFound from '#/components/NotFound';
import Loader from '#/components/Loader';
import styles from './styles.module.css';

import { useTranslation } from "react-i18next";


function PercentChart({ dashboardWidgetId, endpoint, widgetBindDtos, auxiliaryOptionsDto }) {
  const { filters, localFilters, date, polling } = useContext(DashboardContext);
  const { serviceData } = useWidget(
    endpoint,
    filters,
    localFilters,
    date,
    polling,
    dashboardWidgetId,
    null,
    null,
    widgetBindDtos, 
    auxiliaryOptionsDto
  );

  const { t } = useTranslation();

  function renderPercentChart() {
    return Object.keys(serviceData).length > 0 ? (
      <React.Fragment>
        <h3 className={styles.percent}>{serviceData.percent || 0}%</h3>
        <Doughnut
          data={{
            labels: [t('TOTAL'), t('ACTIVE')],
            datasets: [
              {
                data: [
                  serviceData.current,
                  serviceData.total - serviceData.current,
                ],
                backgroundColor: [
                  serviceData.totalColor,
                  serviceData.currentColor,
                ],
              },
            ],
          }}
          options={{
            cutoutPercentage: 85,
            maintainAspectRatio: false,
            legend: {
              display: false,
            },
            layout: {
              padding: {
                top: 16,
                bottom: 24,
              },
            },
            tooltips: { enabled: false },
            hover: { mode: null },
          }}
        />
        <p className={styles.values}>
          <i>{t('ACTIVE')}/{t('TOTAL')}:</i> {serviceData.current || 0}/
          {serviceData.total || 0}
        </p>
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }

  return serviceData ? renderPercentChart() : <Loader />;
}

PercentChart.propTypes = {
  endpoint: PropTypes.shape({
    endpointType: PropTypes.string,
    endpointUrl: PropTypes.string,
  }),
};

export default PercentChart;
